import { BaseError } from './BaseError'

/**
 * Error types that the {@link LoginError} can be.
 *
 * @remarks
 * - 'ALREADY_LOGGED_IN': Listener extension is already logged-in.
 * - 'API_ERROR': An API error occurred during the login process.
 * - 'TIMEOUT': The API call timed-out during the login process.
 * - 'UNKNOWN': There was an error during the login process.
 */
type LoginErrorType = 'ALREADY_LOGGED_IN' | 'API_ERROR' | 'TIMEOUT' | 'UNKNOWN'

/**
 * Error that the {@link DelegationController.login} method can return.
 */
export class LoginError extends BaseError {
  type: LoginErrorType

  /**
   * Creates an instance of GenericError.
   * @param type - GenericError type.
   * @param extensionVersion - Version of the extension where the error occurred.
   * @param message - Error message.
   */
  constructor(
    type: LoginErrorType,
    extensionVersion: string,
    message: string = ''
  ) {
    super(message, extensionVersion)
    this.type = type

    Object.setPrototypeOf(this, LoginError.prototype)
    // Set name explicitly as minification can mangle class names
    Object.defineProperty(this, 'name', { value: 'LoginError' })
  }
}
